/**
 * `Intl.NumberFormat` throws on invalid currency codes. The catch returns a
 * human-readable fallback rather than crashing the render.
 *
 * Locale is intentionally optional — undefined means "use the user's
 * browser locale", which matches what the chat-api emits per store view
 * (EUR for /it, /en in our setup).
 */
export function formatPrice(amount: number, currency: string, locale?: string): string {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
}
